import * as React from 'react';
import { TextLink as TextLinkStandard } from '@emorg-prd/standard-react';

export type TextLinkColor = 'blue' | 'main' | 'accent';

export interface LegacyTextLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
	url?: string;
	external?: boolean;
	color?: TextLinkColor;
	className?: string;
	children?: React.ReactNode;
	target?: '_blank' | '_self' | '_parent' | '_top';
}

const TextLink: React.FC<LegacyTextLinkProps> = ({
	href = '',
	external = false,
	color,
	className,
	children,
	target,
	...rest
}) => {
	const normalizedTarget = target ?? (external ? '_blank' : undefined);

	const optionalClass = [className].filter(Boolean).join(' ');

	// Icon
	const ExternalIcon = (
		<svg
			height="1em"
			width="1em"
			viewBox="0 0 16 16"
			//   className="external-link-icon"
			aria-hidden="true"
			focusable="false"
			style={{ marginLeft: '0.20rem', verticalAlign: 'middle', maxWidth: '0.75rem' }}
		>
			<path fill="currentColor" d="M6 7h9v1H6z" />
			<path
				fill="currentColor"
				d="M13.5 10.207l-.707-.707 2-2-2-2 .707-.707 2.354 2.354a.5.5 0 0 1 0 .707zM10.5 13H.5a.5.5 0 0 1-.5-.5v-10A.5.5 0 0 1 .5 2h10a.5.5 0 0 1 .5.5V5h-1V3H1v9h9v-2h1v2.5a.5.5 0 0 1-.5.5z"
			/>
		</svg>
	);

	// if external === true, add icon
	const content = (
		<>
			{children}
			{external && ExternalIcon}
		</>
	);

	return (
		<TextLinkStandard url={href || rest.url || '#'} target={normalizedTarget} optionalClass={optionalClass}>
			{content}
		</TextLinkStandard>
	);
};

export { TextLink };
